const internalChat = () => ({
  parentNav: 'internal_chat',
  routes: ['internal_chat_dashboard', 'internal_chat_conversation'],
  menuItems: [],
});

export default internalChat;
